{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Izaberite stavku",
  "tableResizer": "Promena veličine",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
